/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MerchantListType {
    SystemAllMerchants = 'SYSTEM_ALL_MERCHANTS',
    SystemPropertyManagerMerchantNetwork = 'SYSTEM_PROPERTY_MANAGER_MERCHANT_NETWORK',
    UserDefined = 'USER_DEFINED'
}

export function MerchantListTypeFromJSON(json: any): MerchantListType {
    return MerchantListTypeFromJSONTyped(json, false);
}

export function MerchantListTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantListType {
    return json as MerchantListType;
}

export function MerchantListTypeToJSON(value?: MerchantListType | null): any {
    return value as any;
}

